<template>
    <div class="d-flex flex-column bg-white">
        <HeaderBar/>
        <div class="reportTitle mt-5 ml-1">Producción de Carne y Leche</div>
        <b-card header-border-variant="Primary" class="shadow  px-0" no-body>
            <b-row no-gutters>

                <b-card-body>
                    <span style="font-weight: 600;font-size: 18px;">
                        
                        <div class="d-flex justify-content-between">
                            <b-form-datepicker id="fecha_ini" name="fecha_ini" v-model="init_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>

                            <b-form-datepicker id="fecha_fin" name="fecha_fin" v-model="end_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>Indicador Productivo</div>
                            <div>Resultado</div>
                        </div>
                    </span>

                    <blockquote class="blockquote mb-0"></blockquote>

                    <b-card-text class="mt-3 mb-3">
                        <div class="d-flex justify-content-between">
                            <div> Carga Animal:</div>
                            <div> {{formatNumber(animal_charge)}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Ganancia peso promedio:</div>
                            <div> {{formatNumber(daily_weight)}}</div>
                        </div>
                        <!-- <div class="d-flex justify-content-between">
                            <div> Peso al detete:</div>
                            <div> {{formatNumber(dest_weight)}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Edad al destete:</div>
                            <div>{{dest_age}} </div>
                        </div> -->

                        <div class="d-flex justify-content-between">
                            <div> Producción de leche:</div>
                            <div> {{formatNumber(milk_liters_data)}} L</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Peso promedio 8 meses:</div>
                            <div> {{formatNumber(EightMonths)}}</div>
                        </div>

                    <div class="d-flex justify-content-between mt-2 px-1">
                        <b-button class="bg-primary w-50 mr-1" @click="showModal(1)">Ganancia de Peso</b-button>
                        <b-button class="bg-primary w-50 mr-1" @click="showModal(2)">Producción de Leche</b-button>
                    </div>
                    <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header>
                        <LineChart v-if="report==1"
                            :width="330"    
                            :data="weighinsData"
                            :options="chartLineOptions"
                        /> 
                        <LineChart v-if="report==2"
                            :width="330" 
                            :data="milkData"
                            :options="chartLineOptions"
                        /> 
                    </b-modal>
                    </b-card-text>
                </b-card-body>

            </b-row>
        </b-card>
        <ControlMenu />
    </div>
</template>


<script>
import { BCard, BRow, BCardBody, BCardText, BButton,BFormDatepicker, BFormRadio} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue';
import Ripple from 'vue-ripple-directive'
import HeaderBar from '@/components/HeaderBar.vue'
import LineChart from '@/components/Basic/Charts/LineChart.vue'
import PieChart from '@/components/Basic/Charts/PieChart.vue'
import BarChart from '@/components/Basic/Charts/BarChart.vue'

export default {
    components: {
        BCard,
        BButton,
        BCardBody,
        BCardText,
        BRow,
        ControlMenu,
        HeaderBar,
        LineChart,
        BarChart,
        BFormRadio,
        BFormDatepicker
    },
    directives: {
    Ripple,
  },
  data(){
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 500)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return{
        dateFormat:'%n/%Y',
        maxCfgDate:maxDate,
        minCfgDate:minDate,
        setLang:'es',
        init_date:now,
        end_date:now,
        isLoading: true,
        modalShow:false,
        report:"Mes",
        animals:0,
        animal_charge:0,
        dest_weight:0,
        dest_age:0,
        incomes:0,
        animalHA:0,
        farmData:null,
        daily_weight:0,
        avg_weight:0,
        expenses:0,
        milk:0,
        milk_liters_data:0,
        dayli:0,
        EightMonths:0,
        animalsData:null,
        weighinsData:{
            labels:[],
            datasets: [
                { 
                    label:'Ganancia de peso',
                    backgroundColor:'#5e8f238a',
                    data:[]
                }
            ]
        },
        milkData:{
            //labels:['Ingresos', 'Gastos'],
            datasets: [
                {   label:'Producción de leche',
                    backgroundColor: ['#5e8f238a'],
                    data:[]
                }
            ]
        },
        chartLineOptions:{
            responsive: false,
            maintainAspectRatio: false,
            backgroundColor: false,
            hover: {
                mode: 'label',
            },
            layout: {
                padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right:20
                },
            },
            
            legend: {
                visible:false,
                position: 'top',
                align: 'start',
                labels: {
                    usePointStyle: true,
                    padding: 25,
                    boxWidth: 9,
                },
            },
        },
    }
  },
  methods:{
    async fetchAnimals(config){
      let farmId= localStorage.getItem('currentFarm');
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            this.animalsData= result.animals;
            this.animals = result.animals.length;
            console.log(this.animals);
            this.fetchFarmData(config);
        })
    },

    async fetchFarmData(config){
        let farmId= localStorage.getItem('currentFarm');
        let self=this;
      fetch(this.$apiUrl+"view/farms/"+farmId, config)
        .then(response => response.json())
        .then(result => {
            console.log(result.farms);
            self.farmData = result.farms;
            let weighinsAnimals=this.animalsData.map(item=>parseFloat(item.weight)).reduce((acc, weight)=> acc+weight);
            this.animal_charge=(weighinsAnimals/400)/parseFloat(this.farmData.total_ha);
            console.log('Total HA')
            console.log(self.farmData);
            this.fetchAnimalWheihins(config);
        })
    },

    async fetchMilk(config){
        let initDate = this.init_date;
        let endDate= this.end_date;
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/milk_records?farm_id="+farmId+"&recperpage=all", config)
            .then(response => response.json())
            .then(result => {
                console.log('Leche');
                console.log(result.milk_records);
                let milk_liters_data =result.milk_records.filter(function(item){
                    let itemRegDate= new Date(item.date);
                    return itemRegDate>= initDateObj && itemRegDate<=endDateObj;
                }).map(
                    item =>parseFloat(item.liters)
                );
                
                if(milk_liters_data.length===0){
                    this.milk_liters_data=0;
                }else{
                    this.milk_liters_data=(milk_liters_data.reduce(
                        (acc, liters)=>acc+liters
                    )/milk_liters_data.length).toFixed(2);
                }

            })
    },

    async fetchAnimalWheihins(config){
        let farmId= localStorage.getItem('currentFarm');
        let self= this;
        fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            this.avg_weight=result.animals.map(
                item =>parseFloat(item.dayli_weight)
            );

            if(self.avg_weight.length===0){
                self.daily_weight=0;
            }else{
                self.daily_weight= (self.avg_weight.reduce(
                    (acc,dayli_weight )=>acc+dayli_weight
                )/self.animals)*-1;
            }

            const today = new Date();

            // Calcular las fechas de 6 y 8 meses atrás
            const sixMonthsAgo = new Date();
            sixMonthsAgo.setMonth(today.getMonth() - 8); // 8 meses atrás
            const eightMonthsAgo = new Date();
            eightMonthsAgo.setMonth(today.getMonth() - 6); // 6 meses atrás

            // Filtrar los registros que están entre 6 y 8 meses
            const filteredRecords = result.animals.filter(record => {
                const birthDate = new Date(record.birthdate);
                return birthDate >= sixMonthsAgo && birthDate <= eightMonthsAgo;
            });

            // Calcular el promedio del peso
            const totalWeight = filteredRecords.reduce((acc, record) => acc + parseFloat(record.weight), 0);
            this.EightMonths = filteredRecords.length > 0 ? (totalWeight / filteredRecords.length).toFixed(2) : 0;

        });/* 
      let farmId= localStorage.getItem('currentFarm');
      //fetch(this.$apiUrl+"list/milk_records?farm_id="+farmId, config)
      fetch(this.$apiUrl+"list/weighins?farm_id="+farmId, config)
        .then(response => response.json())
        .then(result => {
            console.log(result.weighins);
            this.dayli =result.weighins.map(item =>parseFloat(item.weight)).reduce((acc, weight)=>acc+weight) ;
            this.avg_weight=parseFloat(this.dayli)/365
            this.weighinsData.labels= result.weighins.map(item => {return item.date});
            this.weighinsData.datasets[0].data = result.weighins.map(item => {return item.weight});
            console.log(result.weighins);
        }) */
    },



    showModal(rep){
        this.modalShow=true;
        this.report=rep;
    },

    formatNumber(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    dateFormatter(date, months){
        var month = date.getMonth();
        var year = date.getFullYear();
        var day = date.getDate();
        var lastDay = new Date(year, month, 0);
        if (month === 0) {
            month = 11;
            year = year - 1;
        } else {
            month = month - months;
        }
        if (day > lastDay.getDate()) {
            day = lastDay.getDate();
        }
        var newDate = new Date(year, month, 1);
        return newDate;
    },

    fillData(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchMilk(config);
        this.fetchAnimalWheihins(config);
    },
  },
  watch:{
    'init_date': function(val){
        console.log(val);
        this.fillData();
    },
    'end_date': function(val){
        console.log(val);
        this.fillData();
    }
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    let now = new Date()
    //let dateReg= new Date(now.getFullYear(), now.getMonth(), 1);
    this.fetchAnimals(config);
    this.fetchMilk(config);
    //this.fetchAnimalWheihins(config    
  },
}
</script>

<style>
.reportTitle {

    font-weight: 600;
    font-size: 24px;

}

.indicaterEco {
    font-weight: 500;
    font-size: 18px;
}
</style>